/* (ignored) */


//////////////////
// WEBPACK FOOTER
// min-document (ignored)
// module id = 5
// module chunks = 0